<template>

    <div role="complementary" :aria-label="__('messages.complementary_summary_payment')">
        <div class="card card-info-list" >

            <div class="card-header">
                <h2>{{ __('messages.summary_payment') }}</h2>
            </div>

            <div class="card-body" id="content_breakdown">
                <div class="item-columns">
                    <div class="item">
                        {{ summary.roomsTotal }} {{ (summary.roomsTotal > 1 ? __('messages.rooms') :
                            __('messages.room')) }}, {{ summary.days }} {{ summary.days > 1 ? __('messages.nights') :
                            __('messages.night')
                        }}
                    </div>
                    <div class="item-right"><currency-display :amount="summary.totalRate.amount"
                            :showCurrencyCode="true" :applyDecimals="true"></currency-display></div>
                </div>
                <div class="item-columns">
                    <div class="item">
                        {{ __('messages.tax') }}
                    </div>
                    <div class="item-right" v-if="summary.rate.tax > 0">
                        <currency-display :amount="summary.totalRate.totalTaxes" :showCurrencyCode="true"
                            :applyDecimals="true"></currency-display>
                    </div>
                    <div class="item-right" v-if="summary.totalRate.hasTaxes && summary.totalRate.totalTaxes == 0">
                        {{ __('messages.tax_include') | capitalising }}
                    </div>
                    <div class="item-right"
                        v-if="!summary.totalRate.hasTaxes && summary.totalRate.totalTaxes == 0 && !hasTaxExcluded">
                        {{ __('messages.tax_no_include') | capitalising }}
                    </div>
                </div>
                <div class="item-columns" v-if="rapd">
                    <div class="item ">{{ __("messages.total") }}</div>
                    <div class="item-right"><currency-display :amount="summary.totalRate.totalAmount"
                            :showCurrencyCode="true" :applyDecimals="true"></currency-display> </div>
                </div>
                <hr>
                <div class="item-columns title" v-if="!rapd && summary.rate.collectType !== 2">
                    <div class="item">{{ paymentMessage }}</div>
                    <div class="item-right"> <currency-display :amount="summary.totalRate.totalAmount"
                            :showCurrencyCode="true" :applyDecimals="true"></currency-display> </div>
                </div>

                <div class="item-columns title" v-if="!rapd && summary.rate.collectType === 2">
                    <div class="item"> {{ __('messages.pay-accommodation-title') }}</div>
                    <div class="item-right"> <currency-display
                            :amount="breakdownExcludedTotal + summary.totalRate.totalAmount" :showCurrencyCode="true"
                            :applyDecimals="true"></currency-display> </div>
                </div>

                <div class="item-columns title font-green" v-if="rapd">
                    <div class="item ">{{ __('messages.total_booknow') }}</div>
                    <div class="item-right"><currency-display :amount="0" :showCurrencyCode="true"
                            :applyDecimals="true"></currency-display></div>
                </div>

                <div class="item-columns title" v-if="rapd">
                    <div class="item"><small>{{ __('messages.date_limit_booknow') }}</small></div>
                    <div class="item-right">
                        <small class="d-block" v-html="formattedDate"></small>
                    </div>
                </div>

                <breakdown-two v-if="summary.rate.collectType !== 2" :summary="summary" :source="source"
                    :isMetaTotal="isMetaTotal" :currencySite="currencySite"></breakdown-two>

                <hr
                    v-if="summary.rate.collectType == 2 && !(getExchange.currency == summary.totalRate.hotelCollectCurrency && ((summary.totalRate.hotelCollectAmount + this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.originalAmount, 0)) == (summary.totalRate.totalAmount + this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.amount, 0))))" />

                <div class="product-detail-item pt-2 pb-0 mt-1"
                    v-if="summary.rate.collectType == 2 && !(getExchange.currency == summary.totalRate.hotelCollectCurrency && ((summary.totalRate.hotelCollectAmount + this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.originalAmount, 0)) == (summary.totalRate.totalAmount + this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.amount, 0))))">
                    <div>
                        <span class="icons-info font-18 btn-link"></span>
                    </div>
                    <div class="font-12">
                        <div>
                            <div class="text-subtle">
                                {{ getExchange.currency != summary.totalRate.hotelCollectCurrency ?
                                    __('messages.messagge-fee', [getExchange.currency]) : __('messages.messagge-fee', [' '])
                                }}
                                <span v-if="getExchange.currency === summary.totalRate.hotelCollectCurrency">
                                    
                                    <currency-display
                                       class="font-600"
                                        :amount="summary.totalRate.hotelCollectAmount + this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.amount, 0)"
                                        :showCurrencyCode="true" :applyDecimals="true"
                                        :fontWeight="true"
                                        :currencyCode="summary.totalRate.hotelCollectCurrency" :applyConvertion="false"
                                        ></currency-display>
                                    
                                </span>
                                <span v-else>
                                   <currency-display
                                   class="font-600"
                                        :amount="summary.totalRate.hotelCollectAmount + this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.originalAmount, 0)"
                                        :showCurrencyCode="true" :applyDecimals="true"
                                           :fontWeight="true"
                                        :currencyCode="summary.totalRate.hotelCollectCurrency" :applyConvertion="false"
                                        :applySymbol="true"></currency-display>
                                </span>
                                {{
                                    __('messages.messagge-fee-2')
                                }}
                            </div>
                        </div>
                    </div>
                </div>
                <hr v-if="getExchange.base != getExchange.currency && summary.rate.collectType != 2">
                <NotifyCurrency :class="{ 'product-detail-item pt-2 pb-0 d-flex': summary.rate.collectType != 2 }"
                    :applicableClass="false" v-if="summary.rate.collectType != 2" :source="source" />

            </div>
        </div>
        <!-- Sección del descuento con estilo verde -->
        <div class="card  card-info-list mt-3" v-if="discountStore.discountAmount">
            <div class="card-body p-0">
                <span class="text-success">
                    <span class="icons-label-right"></span>
                    {{ selectedDiscountTitle || (discountStore.discountApplicable ? __('messages.discount_title_2') :
                        __('messages.discount_title')) }}
                </span>
                <div class="product-detail-item p-0 pt-2 justify-content-between">
                    <div>
                        <p v-if="!discountStore.discountApplicable">
                            {{ __('messages.discount_subtitle') }}
                            <currency-display :amount="discountStore.discountAmount" :showCurrencyCode="true"
                                :applyDecimals="true" :currencyCode="getExchange.currency"></currency-display>
                            {{ __('messages.discount_subtitle_2') }}
                        </p>
                        <p v-if="discountStore.discountApplicable">
                            <span class="icons-check text-success"></span>
                            {{ __('messages.discount_applicable') }}
                            <currency-display :amount="discountStore.discountAmount" :showCurrencyCode="true"
                                :applyDecimals="true" :currencyCode="getExchange.currency"></currency-display>
                        </p>
                    </div>
                    <div>
                        <button v-if="!discountStore.discountApplicable" type="submit"
                            class="btn btn-link h-100 btn-sm but noPrint"
                            @click="discountStore.discountApplicable = !discountStore.discountApplicable"
                            aria-label="Continue">{{ __('messages.discoubt_title_btn') }}</button>
                        <button v-if="discountStore.discountApplicable" type="submit"
                            class="btn btn-link h-100 btn-sm but noPrint"
                            @click="discountStore.discountApplicable = !discountStore.discountApplicable"
                            aria-label="Continue">{{ __('messages.discoubt_title_btn_delete') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>



</template>

<script>
const site = window.__pt.settings.site;
import { storeToRefs } from 'pinia';
import NotifyCurrency from './NotifyCurrency'
import { useExchangeRateStore } from "../../stores/exchange";
import { useDiscountStore } from '../../stores/discount';
import { StorageService } from '../../services/StorageService';
export default {

    setup() {
        const discountStore = useDiscountStore();
        const exchangeStore = useExchangeRateStore();
        const { getExchange } = storeToRefs(exchangeStore);
        return { discountStore, getExchange };
    },
    data() {
        return {
            currencySite: window.__pt.settings.site.currencySymbol.replace(/[\$\s]/g, ''),
            currencySymbol: window.__pt.settings.site.currency,
            siteConfig: site,
            rapd: this.summary.rate.bookNowPayLater.isBookNowPayLater,
            isMetaTotal: window.__pt.settings.site.isMetaTotal,
            selectedDiscountTitle: null
        };
    },
    props: {
        summary: Object,
        isBooking: {
            type: Boolean,
            default: false
        },
        listrooms: Array,
        isBooking: {
            type: Boolean,
            default: false
        },
        source: String
    },
    computed: {
        formattedDate() {
        const date = this.summary.rate.bookNowPayLater.dateLimitBookNowPayLater;
        const format = this.__("formaters.rapdstep1");  // "dddd D, MMM YYYY<br>HH:mm"
        const dateStr = this.$options.filters.date(date, format).replace(/\./g, '');
        return `${dateStr} ${this.__("formaters.formathrsstep1")}`;
    },
        hasTaxExcluded() {
            return this.summary.rate.breakdownExcluded.some(item => item.title === 'TaxExcluded' && this.summary.rate.country == 'CO');
        },
        breakdownExcludedTotal() {
            return this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.amount, 0);
        },
        showTaxesAndFees() {
            return this.summary.totalRate.totalTaxes > 0 || (this.summary.totalRate.hasTaxes && this.summary.totalRate.totalTaxes === 0 && !this.hasTaxExcluded);
        },
        paymentMessage() {
            if (this.summary.rate.collectType == 2) {
                return this.summary.totalRate.breakdownExcluded.length > 0
                    ? this.__('messages.price')
                    : this.__('messages.pay-accommodation-title');
            }
            return this.__('messages.total');
        },
        discountTitles() {
            return site.discountTitles || [];
        },
    },
    mounted() {
    },
    methods: {
        loadDiscountTitle() {
            const savedTitle = StorageService.getSession('selectedDiscountTitle');
            if (savedTitle) {
                this.selectedDiscountTitle = savedTitle;
            } else {
                this.selectRandomDiscountTitle();
            }
        },
        selectRandomDiscountTitle() {
            if (this.discountTitles.length > 0) {
                const randomIndex = Math.floor(Math.random() * this.discountTitles.length);
                this.selectedDiscountTitle = this.discountTitles[randomIndex];
                StorageService.setSession('selectedDiscountTitle', this.selectedDiscountTitle);
            }
        }
    },
    components: {
        NotifyCurrency
    }
}
</script>
